import ListIcont from '@components/icons/ListIcon';
import StarIcon from '@components/icons/StarIcon';

export function getDocumentIcon(code: string) {
  let icon: () => React.JSX.Element | null = null;

  switch (code) {
    case 'constituent':
      icon = StarIcon;
      break;
    case 'contracts':
      icon = ListIcont;
      break;
  }

  return icon;
}
